angular.module("accordionUpdateAzienda.components", [])
    .component("accordionUpdateAzienda", {
        templateUrl: "ng/components/accordionUpdateAzienda/accordionUpdateAzienda.view.html",
        bindings: {
            azienda: '<',
            listaPf: '<',
            saveAzienda: '&',
            closedModal: '&',
            snapshot: '<',
            portalRunned:'<'
        },
        controller: accordionUpdateAziendaController,
        controllerAs: 'accordionUpdateAziendaCtrl'
    })

function accordionUpdateAziendaController(
    $typeDomainService,
    $scope,
    Pf,
    $rootScope
) {

    var self = this;

    self.$onInit = function () {

        self.supportModel = {
            azienda: jQuery.extend(true, {}, self.azienda),
            cfFirmatario: "",
            dropdown: {
                legalStatuses: [],
                sae: [],
                rae: []
            }
        }

        if (self.azienda.cfFirmatario) {

            self.supportModel.cfFirmatario = self.listaPf
                .find(function (element) {
                    return element.cf == self.azienda.cfFirmatario
                })
        }

        self.getAllLegalStatuses();

        self.getSaeByLegalStatus(self.azienda.formaGiuridica);

        self.getRaeBySae(self.azienda.sae);

    }

    self.setFirmatario = function () {
        self.azienda.cfFirmatario = self.supportModel.cfFirmatario && self.supportModel.cfFirmatario.cf ? self.supportModel.cfFirmatario.cf : null;
    }

    self.saveUpdatedData = function () {

        //popolo l'oggetto luogoEsteso
        if (!self.azienda.sedeLegale.luogoEsteso.nome && self.azienda.sedeLegale.comune) {
            self.azienda.sedeLegale.luogoEsteso.nome = self.azienda.sedeLegale.comune;
            self.azienda.sedeLegale.luogoEsteso.sigla = self.azienda.sedeLegale.provincia;
            self.azienda.sedeLegale.luogoEsteso.cap[0] = self.azienda.sedeLegale.cap;
        }

        if (!self.azienda.sedeConsegna.luogoEsteso.nome && self.azienda.sedeConsegna.comune) {
            self.azienda.sedeConsegna.luogoEsteso.nome = self.azienda.sedeConsegna.comune;
            self.azienda.sedeConsegna.luogoEsteso.sigla = self.azienda.sedeConsegna.provincia;
            self.azienda.sedeConsegna.luogoEsteso.cap[0] = self.azienda.sedeConsegna.cap;
        }

        if (!self.azienda.sedeFatturazione.luogoEsteso.nome && self.azienda.sedeFatturazione.comune) {
            self.azienda.sedeFatturazione.luogoEsteso.nome = self.azienda.sedeFatturazione.comune;
            self.azienda.sedeFatturazione.luogoEsteso.sigla = self.azienda.sedeFatturazione.provincia;
            self.azienda.sedeFatturazione.luogoEsteso.cap[0] = self.azienda.sedeFatturazione.cap;
        }

        self.saveAzienda({
            value: self.azienda
        });
    }

    self.undoModal = function () {

        self.closedModal({
            value: self.azienda
        });
    }
    self.getLegalStatusDescription = function (legalStatusCode) {
        if (self.supportModel.dropdown.legalStatuses && legalStatusCode) {
            var result = self.supportModel.dropdown.legalStatuses.find(function (legalStatus) {
                return legalStatus.id == legalStatusCode.toUpperCase()
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';
    }

    self.getSaeDescription = function (saeCode, saeFromCerved) {
        if (saeFromCerved) {
            if (self.dropdown.saeFromCerved) {
                var result = self.dropdown.saeFromCerved.find(function (sae) {
                    return sae.id == saeCode
                });
                return result ? result.id + ' - ' + result.description : '-';
            } else return '-';
        } else {
            if (self.supportModel.dropdown.sae) {
                var result = self.supportModel.dropdown.sae.find(function (sae) {
                    return sae.id == saeCode
                });
                return result ? result.id + ' - ' + result.description : '-';
            } else return '-';
        }
    }

    self.getRaeDescription = function (raeCode, raeFromCerved) {
        if (raeFromCerved) {
            if (self.dropdown.raeFromCerved) {
                var result = $scope.dropdown.raeFromCerved.find(function (rae) {
                    return rae.id == raeCode
                });
                return result ? result.id + ' - ' + result.description : '-';
            } else return '-';
        } else {
            if (self.supportModel.dropdown.rae) {
                var result = self.supportModel.dropdown.rae.find(function (rae) {
                    return rae.id == raeCode
                });
                return result ? result.id + ' - ' + result.description : '-';
            } else return '-';
        }
    }

    self.getAllLegalStatuses = function () {
        $typeDomainService
            .getAllLegalStatuses()
            .then(function (legalStatuses) {
                self.supportModel.dropdown.legalStatuses = legalStatuses;
            });
    };

    self.getSaeByLegalStatus = function (legalStatus, fromViewHtml) {
        $typeDomainService
            .getSaeByLegalStatus(legalStatus)
            .then(function (saeList) {
                self.supportModel.dropdown.sae = saeList;
            });
    };

    self.getRaeBySae = function (sae, fromViewHtml) {
        $typeDomainService
            .getRaeBySae(sae)
            .then(function (raeList) {
                self.supportModel.dropdown.rae = raeList;
            });
    };

    self.enableConfirm = function () {

        return $scope.showCervedForm &&
            $scope.showCervedForm.$invalid
    }

    var getListOfProv = function () {
        self.listaProvince = $rootScope.comuniMap.map(function (comune) {
            return comune.sigla;
          })
          .filter(function (siglaComune) {
            return siglaComune != "";
          })
          .sort()
          .reduce(function (result, nextItem) {
            return result.includes(nextItem) ? result : result.concat(nextItem);
          }, []);
  }
}